"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOfferCount = exports.GetSpecificOpenOffers = exports.GetAllOpenOffers = exports.GetOwnExpiredOffers = exports.GetOwnFinishedOffers = exports.GetOwnOpenOffers = exports.OfferFields = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.OfferFields = (0, graphql_tag_1.default) `
  fragment OfferFields on Offer {
    id
    consumer
    deployment {
      id
      project {
        id
        metadata
      }
    }
    planTemplate {
      id
      period
      dailyReqCap
      rateLimit
    }
    deposit
    minimumAcceptHeight
    expireDate
    limit
    accepted
    reachLimit
    withdrawn
  }
`;
exports.GetOwnOpenOffers = (0, graphql_tag_1.default) `
  query GetOwnOpenOffers(
    $consumer: String!
    $now: Datetime!
    $offset: Int
    $reachLimit: Boolean = false
  ) {
    offers(
      filter: {
        consumer: { equalTo: $consumer }
        expireDate: { greaterThan: $now }
        reachLimit: { equalTo: $reachLimit }
      }
      first: 10
      offset: $offset
    ) {
      totalCount
      nodes {
        ...OfferFields
      }
    }
  }
  ${exports.OfferFields}
`;
exports.GetOwnFinishedOffers = (0, graphql_tag_1.default) `
  query GetOwnFinishedOffers(
    $consumer: String!
    $now: Datetime!
    $offset: Int
    $reachLimit: Boolean = true
  ) {
    offers(
      filter: {
        consumer: { equalTo: $consumer }
        expireDate: { greaterThan: $now }
        reachLimit: { equalTo: $reachLimit }
      }
      first: 10
      offset: $offset
    ) {
      totalCount
      nodes {
        ...OfferFields
      }
    }
  }
  ${exports.OfferFields}
`;
exports.GetOwnExpiredOffers = (0, graphql_tag_1.default) `
  query GetOwnExpiredOffers(
    $consumer: String!
    $now: Datetime!
    $offset: Int
    $reachLimit: Boolean = false
  ) {
    offers(
      filter: {
        consumer: { equalTo: $consumer }
        expireDate: { lessThan: $now }
        reachLimit: { equalTo: $reachLimit }
      }
      first: 10
      offset: $offset
    ) {
      totalCount
      nodes {
        ...OfferFields
      }
    }
  }
  ${exports.OfferFields}
`;
exports.GetAllOpenOffers = (0, graphql_tag_1.default) `
  query GetAllOpenOffers($now: Datetime!, $offset: Int, $reachLimit: Boolean = false) {
    offers(
      filter: { expireDate: { greaterThan: $now }, reachLimit: { equalTo: $reachLimit } }
      first: 10
      offset: $offset
    ) {
      totalCount
      nodes {
        ...OfferFields
      }
    }
  }
  ${exports.OfferFields}
`;
exports.GetSpecificOpenOffers = (0, graphql_tag_1.default) `
  query GetSpecificOpenOffers(
    $deploymentId: String!
    $now: Datetime!
    $offset: Int
    $reachLimit: Boolean = false
  ) {
    offers(
      filter: {
        expireDate: { greaterThan: $now }
        reachLimit: { equalTo: $reachLimit }
        deploymentId: { equalTo: $deploymentId }
      }
      first: 10
      offset: $offset
    ) {
      totalCount
      nodes {
        ...OfferFields
      }
    }
  }
  ${exports.OfferFields}
`;
exports.GetOfferCount = (0, graphql_tag_1.default) `
  query GetOfferCount($consumer: String!, $reachLimit: Boolean = false) {
    offers(filter: { consumer: { equalTo: $consumer }, reachLimit: { equalTo: $reachLimit } }) {
      totalCount
    }
  }
`;
//# sourceMappingURL=offers.generated.js.map